import request from '@/request/request'
import { tansParams } from "@/utils/src/tansParams";

// 后台契约统一基址（如网关分段不同，仅需修改此处）
const BASE = '/api/equipment-server/'

// 查询全部 LED 设备（含在线状态）
export function listLedDevice() {
    return request({
        url: BASE + 'ledDevice/list',
        method: 'get'
    })
}

// 分页查询通知列表
export function listLedNotice(query) {
    return request({
        url: BASE + `ledNotice/list?${tansParams(query)}`,
        method: 'get',
        data: query
    })
}

// 查询通知详情（含 targetList）
export function getLedNotice(id) {
    return request({
        url: BASE + 'ledNotice/' + id,
        method: 'get'
    })
}

// 新增并下发通知
export function addLedNotice(data) {
    return request({
        url: BASE + 'ledNotice',
        method: 'post',
        data: data
    })
}

// 删除通知（ids 逗号分隔，路径变量）
export function delLedNotice(ids) {
    return request({
        url: BASE + 'ledNotice/delete/' + ids,
        method: 'post'
    })
}
